// extracted by mini-css-extract-plugin
export default {"countrySelect":"PublicPageCountryOfResidenceSelect_countrySelect__zIt1U"};